export class Content {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.title = form.title;
      this.content = form.content;
      this.introduction = form.introduction;
      this.coverImage = form.coverImage;
      this.type = form.type;
      this.category = form.category;
      // this.recommendEquipments = form.recommendEquipments;
    } else {
      this.clear();
    }
  }

  clear() {
    this.id = "";
    this.title = ""; // 标题
    this.content = ""; // 内容
    this.introduction = ""; // 内容简介
    this.coverImage = {
      homeListPicture: "", // 首页列表图片
      marketListPagePicture: "", // 市场内容图片列表图片
      myMarketListPictures: "", // 我的资讯列表图片
      shareCardImage: "", // 分享卡片图片
    };
    this.type = 1; // 内容分类（1:品牌精神2:活动资讯3:新品发布4:运动知识,5:OOTD）
    this.category = 1; // 内容类别(1:市场内容2:Campaign page)
    // this.recommendEquipments = [];
  }
}
